// extracted by mini-css-extract-plugin
module.exports = {"award-icon":"award-icon","awardIcon":"award-icon","cont-awards":"cont-awards","contAwards":"cont-awards","container":"container"};